import { gql } from "@apollo/client";

export const SET_LG_STATUS_ON_INVOICE = gql`
  mutation setLgStatusOnInvoice($input: SetLgStatusInput!) {
    invoice {
      setLgStatusOnInvoice(input: $input) {
        errorMessage
        success
        invoiceId
      }
    }
  }
`;
